import { createFileRoute } from "@tanstack/react-router";
import NotificationSettings from "@/components/settings/notification-settings";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/notifications",
)({
  component: NotificationsSettingsPage,
});

function NotificationsSettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "notifications", actions: ["read", "update"] }]}
    >
      <div className="overflow-x-auto">
        <NotificationSettings />
      </div>
    </RouteGuardPermissions>
  );
}
